export default __webpack_public_path__ + "static/dashboard-82b864e9ff3c262e81c291535fac876a.webp";